const features_bugs = {
	bugs: {
		add_dialog: {
			title: "Fehler melden",
		},
		report_button: "Melden",
		show_all: "Alle Fehler anzeigen",
		title: "Fehler",
	},
	features: {
		add_dialog: {
			inputs: {
				description: "Beschreibung",
				image_added: "Bild hochgeladen",
				image_delete: "Bild löschen",
				image_upload: {
					description:
						"Akzeptierte Formate: .jpg, .jpeg, .png. </br>Dateigröße darf 5 MB nicht überschreiten.",
					image_too_large: "Die Bildgröße darf 5 MB nicht überschreiten.",
					something_wrong: "Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.",
					title: "Optional: Bild hochladen",
				},
				title: "Titel",
			},
			title: "Funktion anfragen",
		},
		request_button: "Anfragen",
		show_all: "Alle Funktionen anzeigen",
		title: "Funktionen",
	},
	title: "Funktionen & Fehler",
};

export default features_bugs;
